import type {
	AtAGlanceExecutionObservation,
	AtAGlanceRequestPhase,
} from './atAGlanceObservation.ts';

type OutcomeAttributes = Pick<
	AtAGlanceExecutionObservation,
	'outcome' | 'reason' | 'statusCode' | 'parsedStatus'
>;

export const createAtAGlanceExecutionRecorder = (
	onObservation?: (event: AtAGlanceExecutionObservation) => void,
) => {
	let attemptCount = 0;
	let phase: AtAGlanceRequestPhase = 'beforeAttempt';
	let activeAttempt = false;
	const observe = (event: Omit<AtAGlanceExecutionObservation, 'attemptCount' | 'phase'>) => {
		try {
			onObservation?.({ ...event, attemptCount, phase });
		} catch {
			// Observation delivery must never change request execution or cancellation.
		}
	};
	observe({ stage: 'operationStarted' });

	return {
		attemptStarted: (): void => {
			phase = 'activeAttempt';
			activeAttempt = true;
			attemptCount += 1;
			observe({ stage: 'attemptStarted' });
		},
		attemptFinished: (attributes: OutcomeAttributes): void => {
			if (!activeAttempt) return;
			activeAttempt = false;
			observe({ stage: 'attemptFinished', ...attributes });
		},
		retryWaiting: (attributes: Pick<AtAGlanceExecutionObservation, 'reason' | 'delayMs'>): void => {
			phase = 'retryDelay';
			observe({ stage: 'retryWait', ...attributes });
		},
		operationFinished: (attributes: OutcomeAttributes): void => {
			observe({ stage: 'operationFinished', ...attributes });
			phase = 'settled';
		},
	};
};
